import styled from "@emotion/styled";

const Wrapper = styled("div")`
    background-color: ${props => props.theme.BODY};
    .main-bg{
        background-color: ${props => props.theme.BODY};
    }
    .main-bg-color{
        background-color: ${props => props.theme.MAIN_COLOR};
    }
    .main-title-color{
        color: ${props => props.theme.PRIMARY_TEXT_1};
    }
    .secondary-title-color{
        color: ${props => props.theme.PRIMARY_TEXT_2};
    }
    .accent-title-color{
        color: ${props => props.theme.MAIN_COLOR};
    }
    .white-title-color{
        color: #FFFFFF;
    }
    .main-cta{
        letter-spacing: .025em;
        color: ${props => props.theme.INVERTED_TEXT};
        font-weight: 500;
        display: inline-block;
        line-height: 1.375;
        background-image: linear-gradient(90deg,#009bff,${props => props.theme.MAIN_COLOR});
        box-shadow: 0 2px 8px 0 rgb(0 34 255 / 8%), 0 2px 8px 0 rgb(0 11 80 / 12%);
        z-index: 1;
    }
    .main-shadow{
        box-shadow: 0 8px 16px 0 rgb(0 0 0 / 5%), 0 16px 64px 0 rgb(0 0 0 / 10%);
        transition-property: transform;
        transition-timing-function: cubic-bezier(.215,.61,.355,1);
        transition-duration: .3s;
    }
    .navbar{
        position: fixed;
        width: 100%;
        min-height: 80px;
        background-color: ${props => props.theme.NAV_BG};
        -webkit-backdrop-filter: saturate(180%) blur(20px);
        backdrop-filter: saturate(180%) blur(20px);
        box-shadow: 0 2px 4px 0 rgb(0 0 0 / 4%), 0 -1px 0 0 rgb(0 0 0 / 8%);
        opacity: 1;
        transition: opacity .3s ease-in-out;
        padding-left: 3.5rem;
        padding-right: 3.5rem;
        color: ${props => props.theme.MAIN_COLOR};
        z-index: 4;
    }

    @media (max-width: 767px) {
        .navbar{
            position: fixed;
            width: 100%;
            min-height: 80px;
            background-color: ${props => props.theme.NAV_BG};
            -webkit-backdrop-filter: saturate(180%) blur(20px);
            backdrop-filter: saturate(180%) blur(20px);
            box-shadow: 0 2px 4px 0 rgb(0 0 0 / 4%), 0 -1px 0 0 rgb(0 0 0 / 8%);
            opacity: 1;
            transition: opacity .3s ease-in-out;
            padding-left: 1.5rem;
            padding-right: 1.5rem;
            color: ${props => props.theme.MAIN_COLOR};
            z-index: 4;
        }
    }


    //PROYECTOS

    .proyectos-container{
        border-bottom: 1px solid #e2e8f0;
        background-image: linear-gradient(
            180deg
            ,${props => props.theme.BODY},${props => props.theme.BODY_FADE});
    }
    .card-project{
        break-inside: avoid;
        page-break-inside: avoid;
        box-shadow: 0 8px 16px 0 rgb(0 0 0 / 5%), 0 16px 64px 0 rgb(0 0 0 / 10%);
        transition-property: transform;
        transition-timing-function: cubic-bezier(.215,.61,.355,1);
        transition-duration: .3s;
        border-radius: .5rem;
    }
    .tab-bg{
        background-color: ${props => props.theme.TAB_BG};
    }
    .tab-active{
        color: #fff;
        background-image: linear-gradient(90deg,#009bff,${props => props.theme.MAIN_COLOR});
        box-shadow: 0 2px 8px 0 rgb(0 34 255 / 8%), 0 2px 8px 0 rgb(0 11 80 / 12%);
    }
    .tab-inactive{
        color: ${props => props.theme.PRIMARY_TEXT_2};
        background-color: rgba(0,0,0,.0);
        cursor: pointer;
    }

    // CAPABILITIES

    .capabilities-container{
        border-bottom: 1px solid #e2e8f0;
    }

    // TOOLS

    .tools-container{
        border-bottom: 1px solid #e2e8f0;
    }

    .card-tools{
        background-color: ${props => props.theme.CARD_TOOL_BG};
        break-inside: avoid;
        page-break-inside: avoid;
        box-shadow: 0 8px 16px 0 rgb(0 0 0 / 5%), 0 16px 64px 0 rgb(0 0 0 / 10%);
        transition-property: transform;
        transition-timing-function: cubic-bezier(.215,.61,.355,1);
        transition-duration: .3s;
        border-radius: .5rem;
    }

    .pulse{
        background-color: ${props => props.theme.MAIN_COLOR};
        display: inline-block;
        vertical-align: middle;
        padding-bottom: 3px;
        padding-right: 6px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-clip: padding-box;
        box-shadow: 0 0 0 rgb(0 98 255 / 40%);
        -webkit-animation: pulse 2s infinite;
        animation: pulse 2s infinite;
    }

    @keyframes pulse {
        0% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 ${props => props.theme.MAIN_COLOR};
          opacity: 0.7
        }
        
        70% {
          transform: scale(1);
          box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
        }
        
        100% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
        }
      }

    // ERROR

    .error-container{
        border-bottom: 1px solid #e2e8f0;
    }
`;

export { Wrapper };